import React from "react";
import autobind from "class-autobind";
import {FormGroup} from "../group/index";
import {Input} from "../input/index";
import {Button} from "../../button/index";
import { FaMinusCircle, FaCopy } from "react-icons/fa";
import {InputBox} from "../input.box/index";
import { Tooltip } from "../../tooltip/index";
import { Modal } from "../../layout/modal/index";
import { ModalContent } from "../../layout/modal/content";
import { DateTimePicker } from "../datetime/index";
import moment from "moment-timezone";

interface Props {
  formats: RestaurantSchema["settings"]["region"]["formats"];
  locale: string;
  timezone: string;
  values: BusinessDateTimeRanges;
  onChange: (values: BusinessDateTimeRanges) => void;
  allowNone?: boolean;
}

interface State {
  modal: number | null;
  modal_type: "start" | "end";
}

export class DateTimeRanges extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      modal: null,
      modal_type: "start",
    };
  }

  setModal(modal: number | null, modal_type: "start" | "end") {
    this.setState({ modal, modal_type });
  }

  copy(i: number) {
    const values = [ ...this.props.values ];
    const value = { ...values[i] };
    values.push(value);
    this.props.onChange(values);
  }

  remove(i: number) {
    const values = [ ...this.props.values ];
    values.splice(i, 1);
    this.props.onChange(values);
  }

  change(i: number, key: keyof BusinessDateTimeRange, value: number) {
    const values = [ ...this.props.values ];
    values[i][key] = value;
    this.props.onChange(values);
  }

  render() {

    const { values, allowNone, locale, timezone, formats } = this.props;
    const { modal, modal_type } = this.state;
    const dtFormat = `${formats.date} ${formats.time}`;

    return (
      <div className="m-t-2">

        { values.map((value, i) => {

          return (
            <div key={i} className="flex-line" style={{ alignItems: "flex-end" }}>

              <InputBox className="no-round width32 text-center">
                <p className="big font-bold" style={{ lineHeight: "36px" }}>{i + 1}</p>
              </InputBox>

              <div className="flex-line" style={{ alignItems: "flex-end" }}>
                <FormGroup
                  className="m-b-0"
                  title={i === 0 ? "Start" : null}
                  small_title={true}
                  no_border={true}>
                  <Input
                    type="text"
                    value={value.start ? moment.tz(value.start, timezone).format(dtFormat) : ""}
                    placeholder="Click to select"
                    className="no-round width200"
                    onClick={() => this.setModal(i, "start")}
                    readOnly={true}
                    required={true}
                  />
                </FormGroup>

                <FormGroup
                  className="m-b-0"
                  title={i === 0 ? "End" : null}
                  small_title={true}
                  no_border={true}>
                  <Input
                    type="text"
                    value={value.end ? moment.tz(value.end, timezone).format(dtFormat) : ""}
                    placeholder="Click to select"
                    className="no-round width200"
                    onClick={() => this.setModal(i, "end")}
                    readOnly={true}
                    required={true}
                  />
                </FormGroup>

              </div>

              { (allowNone || values.length !== 1) &&
                <Tooltip text="Delete" width={65} position="top">
                  <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => this.remove(i)}>
                    <FaMinusCircle/>
                  </Button>
                </Tooltip>
              }
              <Tooltip text="Copy" width={65} position="top">
                <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => this.copy(i)}>
                  <FaCopy/>
                </Button>
              </Tooltip>

            </div>
          );

        })}

        <Modal
          active={modal !== null}
          width={265}
          closeButton={false}
          close={() => this.setModal(null, "start")}>
          {(modal !== null) && (
            <ModalContent>
              <DateTimePicker
                locale={locale}
                timezone={timezone}
                onSelect={(millis) => {
                  this.change(modal, modal_type, millis);
                  this.setModal(null, "start");
                }}
              />
            </ModalContent>
          )}
        </Modal>

      </div>
    );
  }

}
